import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { qtyStep } from "@/lib/constants";

// Raw / bought-out only: supplier matching + purchasing rules.
export function BomSourcingFields({ form, set }) {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Category (for Supplier Matching)</Label>
          <Input value={form.category} onChange={(e) => set("category", e.target.value)} placeholder="e.g. Fasteners" data-testid="bom-form-category" />
          <p className="text-[10px] text-slate-400">Suppliers tagged with this category are suggested first on new POs.</p>
        </div>
        <div className="space-y-1.5">
          <Label>Supplier Lead Time (Days)</Label>
          <Input type="number" min="0" step="1" value={form.lead_time_days}
            onChange={(e) => set("lead_time_days", e.target.value)} data-testid="bom-form-lead-time" />
          <p className="text-[10px] text-slate-400">Days from placing a PO to delivery. Used to flag late reorders.</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Pack / Order Multiple ({form.unit})</Label>
          <Input type="number" min="0" step={qtyStep(form.unit)} value={form.pack_size}
            onChange={(e) => set("pack_size", e.target.value)} data-testid="bom-form-pack-size" />
          <p className="text-[10px] text-slate-400">Auto-orders round up to a multiple of this. 0 = any quantity.</p>
        </div>
        <div className="space-y-1.5">
          <Label>Min Order Qty ({form.unit})</Label>
          <Input type="number" min="0" step={qtyStep(form.unit)} value={form.moq}
            onChange={(e) => set("moq", e.target.value)} data-testid="bom-form-moq" />
          <p className="text-[10px] text-slate-400">Supplier minimum. Auto-orders never fall below this.</p>
        </div>
      </div>
    </>
  );
}
